export const CreditNotesStatusFilterList = [
    { id: "Unposted", name: "Unposted" },
    { id: "Posted", name: "Posted" },
  ];